import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ICustomReportFilter } from '@principle-theorem/principle-core/interfaces';
import {
  CustomReportFilter,
  ReportBuilderDataSourceInstance,
} from '@principle-theorem/reporting';

@Component({
  selector: 'pr-custom-report-filter',
  templateUrl: './custom-report-filter.component.html',
  styleUrls: ['./custom-report-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, NgCommonModule],
})
export class CustomReportFilterComponent {
  filter = input.required<ICustomReportFilter>();
  dataSource = input.required<ReportBuilderDataSourceInstance>();
  isTemporary = input<boolean>(false);

  summary = computed(() =>
    CustomReportFilter.getSummarySegments(
      this.dataSource().factTable,
      this.filter()
    )
  );
}
